// @ts-nocheck
import { useState, useEffect } from "react";
import Container from "../Componentes/Container";
import Cabecera from "../Componentes/Cabecera";
import InfoEstudiante from "../Componentes/InfoEstudiante";
import BotonQr from "../Componentes/BotonQr";
import ModalQr from "../Componentes/ModalQr";
import ImgEstudiante from "../Componentes/ImgEstudiante";
import axios from "axios";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import { Stack, CircularProgress } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useBody } from "../../Body/state/BodyContext";
import { RUTA_API_CREDENCIAL } from "../../Contantes/Constantes";
import { useAuth } from "../../Auth/State/AuthContext";
import BotonCertificado from "../Componentes/BotonCertificado";
import { generarPDF } from "../utils/generarHistoriaAcademicaPdf";
import ErrorQR from "../Componentes/ErrorQR";

export default function Credencial() {
  
  const axiosInstance = setupInterceptorsTo(axios.create());
  // @ts-ignore
  const { googleImageBase64, setMessage } = useBody();
  // @ts-ignore
  const { user } = useAuth();
  const [credencial, setCredencial] = useState({});
  const [urlQr, setUrlQr] = useState("");
  const [loadingUrlQR, setLoadingUrlQR] = useState(true);
  const [loadingCredencial, setLoadingCredencial] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [errorCredencial, setErrorCredencial] = useState(false);
  const [counter, setCounter] = useState({ minutes: 0, seconds: 0 });
  const desktop = useMediaQuery("(min-width: 1000px)");
  const [loadingCertificado, setLoadingCertificado] = useState(false);
  const [certificado, setCertificado] = useState(null);

  const handleOpen = () => {
    setOpenModal(true);
    if (counter.seconds === 0 && counter.minutes === 0) {
      setLoadingUrlQR(true);
      axiosInstance({
        method: "GET",
        url: `${RUTA_API_CREDENCIAL}/constancia/encriptar/${user.uid}`, //DEJEN RUTA_API_CREDENCIAL PORQUE LA OTRA NO EXISTE
      })
        .then((data) => {
          setUrlQr(data.data);
          setLoadingUrlQR(false);
          setCounter({ minutes: 10, seconds: 0 });
        })
        .catch((err) => {
          setMessage("Ocurrió un error al generar el QR");
        });
    }
  };

  const extraerDatosCredencial = async (data) => {
    return {
      "Apellido y Nombre": data.apellido_nombre,
      "Nº Legajo": data.legajo,
      "Tipo de Documento": data.tipo_doc,
      "Número de Documento": data.nro_doc,
      "Categoría": data.categoria,
    };
  };

  const handleClose = () => setOpenModal(false);
  const updateCounter = (newCounter) => setCounter(newCounter);

  useEffect(() => {
    setLoadingCredencial(true);

    if (user.uid) {
      axiosInstance({
        method: "GET",
        url: `${RUTA_API_CREDENCIAL}/credencial/${user.uid}`,
      })
        .then(async (data) => {
          const datos = await extraerDatosCredencial(data.data);
          setCredencial(datos);
          setLoadingCredencial(false);
        })
        .catch((err) => {
          setErrorCredencial(true);
          setMessage("Ocurrió un error al obtener los datos de la credencial");
        });
    }
  }, [user]);

  const handleCertificadoInfo = () => {
    if (certificado) {
      certificado.save();
      return;
    }
    setLoadingCertificado(true);
    axiosInstance({
      method: "GET",
      url: `${RUTA_API_CREDENCIAL}/constancia/pdf/${user.uid}`,
    })
      .then((data) => {
        const newCertificado = generarPDF(data.data);
        setCertificado(newCertificado);
        setLoadingCertificado(false);
        newCertificado.save();
      })
      .catch((err) => {
        setMessage("Ocurrió un error al generar el certificado");
      });
  };

  return (
    <Container>
      <Cabecera />
      {loadingCredencial ? (
        <Stack sx={{ justifyContent: "center", alignItems: "center", flex: 1 }}>
          <CircularProgress />
        </Stack>
      ) : (
        <>
          {errorCredencial ? (
            <ErrorQR error={"Error al cargar Datos"} descripcion={"No se han podido traer los datos de su credencial"} />
          ) : (
            <>
              <ImgEstudiante foto={googleImageBase64} />
              <Stack
                sx={{
                  flexDirection: "column",
                  ...(desktop && {
                    flexDirection: "row",
                    width: "100%",
                    justifyContent: "space-evenly",
                  }),
                }}
              >
                <InfoEstudiante data={credencial} />
                <Stack sx={{ justifyContent: "center", alignItems: "center" }}>
                  <BotonQr handleOpen={handleOpen} />
                  <BotonCertificado
                    loadingCertificado={loadingCertificado}
                    handleCertificadoInfo={handleCertificadoInfo}
                  />
                </Stack>
              </Stack>
            </>
          )}
        </>
      )}
      <ModalQr
        openModal={openModal}
        handleClose={handleClose}
        counter={counter}
        updateCounter={updateCounter}
        loading={loadingUrlQR}
        urlQr={urlQr}
      />
    </Container>
  );
}
